<h3 [innerHTML]="findMasterText.heading"></h3>
<div [innerHTML]="findMasterText.mainText" class="id37-text2 text-light"></div>
